import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button } from "react-bootstrap";

const TriggerComponent = ({
  disabled,
  title,
  handleSubmit,
  actionable,
  bgColor,
  icon,
}) => {
  return (
    <div className="opp-button-container">
      <div className="opp-button">
        <Button
          onClick={handleSubmit}
          disabled={!actionable && disabled}
          style={{
            whiteSpace: "nowrap", // Prevent text from breaking onto the second line
            ...(actionable && disabled
              ? { backgroundColor: "#FF792955" }
              : !actionable && bgColor
              ? { backgroundColor: bgColor }
              : {}),
          }}
        >
          {title}
          {icon && (
            <FontAwesomeIcon
              icon={icon}
              color={"white"}
              style={{ paddingLeft: "15px" }}
            />
          )}
        </Button>
      </div>
    </div>
  );
};

export default TriggerComponent;
